import 'styles/styles.scss'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
//import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import reducer from './components/order-form/reducers/index'
import OrderFormContainer from './components/order-form/containers/OrderFormContainer'
import 'all-js/placeholder-input'

import 'header/login/login'
import 'mainmenu/mainmenu'

let store = createStore(
    reducer,
    applyMiddleware(
        thunkMiddleware//,
        //createLogger()
    )
)

store.subscribe(() => {
    if (store.getState().app.isFormReadyForSubmit) {
        document.getElementById('order_form').submit()
    }
})

render(
    <Provider store={store}>
        <OrderFormContainer/>
    </Provider>,
    document.getElementById('order_details')
)